import $ from "jquery";

const SELECTOR_INPUT = '[data-js="mainMenuToggle"]';
const SELECTOR_NAV = '[data-js="mainMenuNav"]';

const handleChange = () => {
  if (this.checked) {
    $("body").addClass("is-menu-open");
    $(SELECTOR_NAV).attr("aria-expanded", true);
  } else {
    $("body").removeClass("is-menu-open");
    $(SELECTOR_NAV).attr("aria-expanded", false);
  }
};

$(document).on("change", SELECTOR_INPUT, handleChange);
